/**
 * Dev-only mock for POST Crash/Final and Auth/Refresh when REACT_APP_MOCK_OFFLINE_API=true.
 */

import { INCIDENT_SCHEMA_VERSION } from './contract'

const MOCK_FINAL_IDS = new Map()

export function isMockableUrl(url) {
  return (
    typeof url === 'string' &&
    (url.includes('/Crash/Final') || url.includes('/Auth/Refresh'))
  )
}

/**
 * @returns {Response}
 */
export async function mockFetchResponse(url, options) {
  if (url.includes('/Auth/Refresh')) {
    const body = JSON.parse(options.body || '{}')
    return new Response(
      JSON.stringify({
        responseData: {
          token: `mock-access-${Date.now()}`,
          refreshToken: body.refreshToken || `mock-refresh-${Date.now()}`
        }
      }),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    )
  }

  if (url.includes('/Crash/Final')) {
    const idem = options.headers?.['Idempotency-Key'] || options.headers?.['idempotency-key']
    if (idem && MOCK_FINAL_IDS.has(idem)) {
      return new Response(
        JSON.stringify({
          responseData: MOCK_FINAL_IDS.get(idem),
          responseAnyError: false
        }),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      )
    }
    const serverId = `mock-${Date.now()}`
    const data = {
      crash_id: serverId,
      schemaVersion: INCIDENT_SCHEMA_VERSION,
      duplicate: false
    }
    if (idem) MOCK_FINAL_IDS.set(idem, data)
    return new Response(
      JSON.stringify({
        responseData: data,
        responseAnyError: false
      }),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    )
  }

  return new Response(JSON.stringify({ error: 'mock: unhandled' }), { status: 404 })
}
